import React from "react";
import Slider from "react-slick";
import classes from "./Testimonals.module.css";
import Shimmer from "../../components/Shimmer";
import { useTestimonals } from "../../Pregrine/Testimonals/useTestimonals";

const Testimonals = () => {
  const talonProps = useTestimonals();
  const { TestimonalsData } = talonProps;

  const settings = {
    dots: true,
    arrows: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  };

  return (
    <>
      {TestimonalsData &&
      TestimonalsData.testimonialdata &&
      TestimonalsData.testimonialdata.length ? (
        <section className={`${classes.cust_bg} pt-3 pb-3 testimonialSlider`}>
          <div className="container">
            <div className="row m-0">
              <div className={`${classes.title} text-center text-white`}>
                Customer Speak
              </div>
            </div>
            <div className="row m-0">
              <Slider {...settings}>
                {TestimonalsData.testimonialdata.map((item, index) => (
                  <div className={classes.item} key={index}>
                    <div className="row m-0">
                      {/* <div className="col-sm-1">
                        <img src={item.image} alt={item.name} loading="lazy" />
                      </div> */}
                      <div
                        className={`col-sm-11 ${classes.slider_btm_details}`}
                      >
                        <p className="">"{item.message}"</p>
                        <p>
                          <b>{item.name}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>
      ) : (
        <>
          <Shimmer width={"100%"} height="200px" />
        </>
      )}
    </>
  );
};

export default Testimonals;
